import { render } from "./UnificacionCodigos.vue?vue&type=template&id=3318d642&scoped=true"
import script from "./UnificacionCodigos.vue?vue&type=script&lang=js"
export * from "./UnificacionCodigos.vue?vue&type=script&lang=js"

import "./UnificacionCodigos.vue?vue&type=style&index=0&id=3318d642&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3318d642"]])

export default __exports__